import Http from "../../common/utils/Http";

export const resetMfa = async (params) => {
    try {
        return await Http.post('pr/settings/reset-mfa', params);
    } catch ({ errorMessages }) {
        throw errorMessages;
    }
}
